import type { ComponentProps } from "react";

import type SwPageContent from "app/components/page-content";
import { useCollectingCampaignPoll } from "app/pages/digital-marketing/keywords-campaigns/shared/hooks/useCollectingCampaignPoll";
import { useIsCampaignCollecting } from "app/pages/digital-marketing/keywords-campaigns/shared/hooks/useIsCampaignCollecting";

import { DataCollectionInProgressBanner } from "./DataCollectionInProgressBanner";
import { RankTrackerPageContentWrapper } from "./styles";

export const RankTrackerPageContent = ({ children, ...rest }: ComponentProps<typeof SwPageContent>) => {
    const isCollecting = useIsCampaignCollecting();
    useCollectingCampaignPoll();

    return (
        <RankTrackerPageContentWrapper {...rest}>
            {isCollecting ? <DataCollectionInProgressBanner /> : null}
            {children}
        </RankTrackerPageContentWrapper>
    );
};
